/* Static navigation config for the admin dashboard shell. */
export const sidebarNavItems = [
  { icon: 'ri-dashboard-line', label: 'Dashboard', path: '/dashboard' },
  { icon: 'ri-bar-chart-2-line', label: 'Reports', path: '/dashboard/reports' },
  { icon: 'ri-bar-chart-grouped-line', label: 'Report Builder', path: '/dashboard/report-builder' },
  { icon: 'ri-shopping-bag-3-line', label: 'Orders', path: '/dashboard/orders' },
  { icon: 'ri-restaurant-2-line', label: 'Menu', path: '/dashboard/menu' },
  { icon: 'ri-qr-code-line', label: 'QR & Tables', path: '/dashboard/qr' },
  { icon: 'ri-calendar-check-line', label: 'Reservations', path: '/dashboard/reservations' },
  { icon: 'ri-archive-line', label: 'Inventory', path: '/dashboard/inventory' },
  { icon: 'ri-user-heart-line', label: 'Customers', path: '/dashboard/customers' },
  { icon: 'ri-chat-smile-2-line', label: 'Feedback', path: '/dashboard/feedback' },
  { icon: 'ri-takeaway-line', label: 'Aggregators', path: '/dashboard/aggregators' },
  { icon: 'ri-building-line', label: 'Outlets', path: '/dashboard/outlets' },
  { icon: 'ri-team-line', label: 'Staff', path: '/dashboard/staff' },
  { icon: 'ri-settings-3-line', label: 'Settings', path: '/dashboard/settings' },
  { icon: 'ri-vip-crown-line', label: 'Billing & Plans', path: '/dashboard/billing' },
];
